import React from 'react';
import { createPortal } from 'react-dom';

const OrderDetailsModals = ({
  deleteConfirm,
  setDeleteConfirm,
  handleDeleteOrder,
  cancelPaymentConfirm,
  setCancelPaymentConfirm,
  handleCancelPayment,
  showSystemConfirm,
  setShowSystemConfirm,
  handleAddOrder
}) => {
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2147483647,
    padding: '20px',
  };

  const contentStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '40px',
    maxWidth: '450px',
    width: '100%',
    boxShadow: '0 0 30px rgba(0, 0, 0, 0.5)',
    textAlign: 'center',
    position: 'relative',
    zIndex: 2147483647,
    color: '#000000',
    border: '2px solid #ffffff'
  };

  const btnContainerStyle = {
    display: 'flex',
    gap: '15px',
    justifyContent: 'center',
    marginTop: '30px'
  };

  const cancelBtnStyle = {
    padding: '10px 25px',
    background: '#e2e8f0',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: '600',
    color: '#475569'
  };

  const confirmBtnStyle = {
    padding: '10px 25px',
    background: '#ef4444',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: '600',
    color: '#ffffff'
  };

  return (
    <>
      {/* Silme Onay Modalı */}
      {deleteConfirm && createPortal(
        <div style={overlayStyle} onClick={() => setDeleteConfirm(null)}>
          <div style={contentStyle} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 20px', color: '#1e293b' }}>Siparişi Sil</h3>
            <p style={{ color: '#64748b', fontSize: '16px' }}>Bu siparişi silmek istediğinizden emin misiniz?</p>
            <div style={{ margin: '20px 0', padding: '15px', background: '#f1f5f9', borderRadius: '8px', fontWeight: '500' }}>
              {deleteConfirm.roomName} - {deleteConfirm.productType === 'plise' ? (
                <>
                  {deleteConfirm.pliseProduct1Name}
                  {deleteConfirm.pliseProduct2Name ? ` + ${deleteConfirm.pliseProduct2Name}` : ''}
                </>
              ) : deleteConfirm.productName}
            </div>
            <div style={btnContainerStyle}>
              <button style={cancelBtnStyle} onClick={() => setDeleteConfirm(null)}>Vazgeç</button>
              <button style={confirmBtnStyle} onClick={handleDeleteOrder}>Evet, Sil</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* Ödeme İptal Onay Modalı */}
      {cancelPaymentConfirm && createPortal(
        <div style={overlayStyle} onClick={() => setCancelPaymentConfirm(null)}>
          <div style={contentStyle} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 20px', color: '#1e293b' }}>Ödemeyi İptal Et</h3>
            <p style={{ color: '#64748b', fontSize: '16px' }}>Bu ödeme işlemini iptal etmek istediğinizden emin misiniz?</p>
            <div style={{ margin: '20px 0', padding: '15px', background: '#fff1f2', borderRadius: '8px', color: '#be123c', fontWeight: '600', fontSize: '18px' }}>
              Tutar: {cancelPaymentConfirm.amount} ₺
            </div>
            <div style={btnContainerStyle}>
              <button style={cancelBtnStyle} onClick={() => setCancelPaymentConfirm(null)}>Vazgeç</button>
              <button style={confirmBtnStyle} onClick={() => handleCancelPayment(cancelPaymentConfirm)}>Evet, İptal Et</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* Sistem Seçim Onay Modalı (Stor/Zebra) */}
      {showSystemConfirm && createPortal(
        <div style={overlayStyle}>
          <div style={contentStyle}>
            <div style={{ marginBottom: '20px' }}>
              <i className="fas fa-exclamation-triangle" style={{ fontSize: '48px', color: '#d45a08' }}></i>
            </div>
            <h3 style={{ margin: '0 0 15px', color: '#1e293b' }}>Sistem Seçimi Eksik</h3>
            <p style={{ color: '#64748b', fontSize: '16px', lineHeight: '1.6', margin: '0 0 25px' }}>
              Herhangi bir sistem (Jumbo, Alt Etek, vb.) seçmediniz.<br /><br />
              Siparişinizi bu şekilde kaydetmeyi onaylıyor musunuz?
            </p>
            <div style={btnContainerStyle}>
              <button style={cancelBtnStyle} onClick={() => setShowSystemConfirm(false)}>Düzenle</button>
              <button style={{ ...confirmBtnStyle, background: '#d45a08' }} onClick={() => { setShowSystemConfirm(false); handleAddOrder(null, true); }}>Evet, Onayla</button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default OrderDetailsModals;
